import { render } from "./LocationsPage.vue?vue&type=template&id=bd03d0ac&scoped=true"
import script from "./LocationsPage.vue?vue&type=script&lang=js"
export * from "./LocationsPage.vue?vue&type=script&lang=js"

import "./LocationsPage.vue?vue&type=style&index=0&id=bd03d0ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd03d0ac"]])

export default __exports__